import React from "react";
interface DashboardProfileHeroProps {
  firstName: string;
  t: (key: string, options?: any) => string;
  className?: string;
}
const DashboardProfileHero = ({
  firstName,
  t,
  className = ""
}: DashboardProfileHeroProps) => {
  return <div className={`w-full py-8 px-4 ${className}`}>
      <div className="container mx-auto flex flex-col items-center  space-y-6">
        
        {/* Row 1 - Uplivion Logo */}
        <div className="flex justify-center">
          <img src="/uplivion-logo.svg" alt="Uplivion Logo" className="h-10 md:h-10 w-auto" />
        </div>
        
        {/* Row 2 - Uplivion Sphere */}
        <div className="flex justify-center">
          <img src="/uplivion-sphere-transparent.png" alt="Uplivion Sphere" className="h-32 md:h-32 w-auto uplivion-sphere-transparent" />
        </div>
        
        {/* Row 3 - Greeting */}
        <div className="text-center space-y-2">
          <h1 className="text-4xl md:text-4xl sm:text-3xl text-[#3C363D] font-normal">
            {t('greeting', {
            name: firstName
          })}
          </h1>
          <p className="text-gray-600 text-sm md:text-base">
            {t('welcome')}
          </p>
        </div>
        
      </div>
    </div>;
};
export default DashboardProfileHero;